import { render, staticRenderFns } from "./CVZh.vue?vue&type=template&id=767983b8&scoped=true&"
import script from "./CVZh.vue?vue&type=script&lang=js&"
export * from "./CVZh.vue?vue&type=script&lang=js&"
import style0 from "./CVZh.vue?vue&type=style&index=0&id=767983b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767983b8",
  null
  
)

export default component.exports